<template>
    <form
        id="formReportContent"
        ref="form"
        name="reportContentForm"
        method="POST"
        class="form reportContent formGrid padding-top-20"
        @submit.prevent="recaptchaFormSubmit($event.target)">
        <div class="formRequiredText">
            {{ trans('REQUIRED') }}
        </div>
        <div class="reportContent__formGrid">
            <div class="reportContent__right">
                <h4
                    id="reportContent--problems"
                    class="sectionSubline">
                    {{ trans('REPORT_CONTENT_PROBLEM_HEADLINE') }}<sup>*</sup>
                </h4>
                <div class="form__row form__row--radio form__row--inputGroupList">
                    <div
                        class="form__rowItem form__rowItem--inputGroup"
                        role="group"
                        aria-labelledby="reportContent--problems">
                        <FormCheckbox
                            v-for="(choice, index) in form.report_content_problems.choices"
                            :id="`${ form.report_content_problems.id }_${ choice.value }`"
                            :key="index"
                            :field="form.report_content_problems"
                            :value="choice.value"
                            :label="choice.label"
                            :name="choice.name"
                            :required="false"
                            :data-gtm="`formReportContent--${ choice.value }`"
                            :checked="form.report_content_problems.value.includes(choice.value)" />
                    </div>
                </div>
                <h4
                    id="reportContent--damaged"
                    class="sectionSubline">
                    {{ trans('REPORT_CONTENT_DAMAGED_HEADLINE') }}<sup>*</sup>
                </h4>
                <div class="form__row form__row--radio form__row--inputGroupList">
                    <div
                        class="form__rowItem form__rowItem--inputGroup"
                        role="group"
                        aria-labelledby="reportContent--damaged">
                        <FormRadio
                            v-for="(choice, index) in form.report_content_damaged.choices"
                            :id="`${ form.report_content_damaged.id }_${ choice.value }`"
                            :key="index"
                            :field="form.report_content_damaged"
                            :value="choice.value"
                            :label="choice.label"
                            :data-gtm="`formReportContent--${ choice.value }`"
                            :checked="form.report_content_damaged.value === choice.value" />
                    </div>
                </div>
                <h4
                    id="reportContent--who"
                    class="sectionSubline">
                    {{ trans('REPORT_CONTENT_WHO_HEADLINE') }}<sup>*</sup>
                </h4>
                <div class="form__row form__row--inputGroupList">
                    <div
                        class="form__rowItem form__rowItem--inputGroup"
                        role="group"
                        aria-labelledby="reportContent--who">
                        <FormCheckbox :field="form.report_content_owner" />
                        <FormCheckbox :field="form.report_content_conscience" />
                        <FormCheckbox :field="form.report_content_confirm_correctness" />
                        <FormCheckbox :field="form.report_content_false_accusation" />
                    </div>
                </div>
            </div>
            <div class="reportContent__left">
                <h4 class="sectionSubline">
                    {{ trans('REPORT_CONTENT_DAMAGED_HEADLINE') }}<sup>*</sup>
                </h4>
                <div class="form__row">
                    <div class="form__rowItem">
                        <FormInput :field="form.report_content_firstName" />
                    </div>
                    <div class="form__rowItem">
                        <FormInput :field="form.report_content_lastName" />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__rowItem form__rowItem--mail">
                        <FormInput :field="form.report_content_email" />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__rowItem form__rowItem--company">
                        <FormInput :field="form.report_content_company" />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__rowItem form__rowItem--street">
                        <FormInput
                            :field="form.report_content_street"
                            :label="trans('FORM_REGISTER_STREET_NO')" />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__rowItem form__rowItem--zipCode">
                        <FormInput :field="form.report_content_zipCode" />
                    </div>
                    <div class="form__rowItem form__rowItem--city">
                        <FormInput :field="form.report_content_city" />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__rowItem form__rowItem--country">
                        <FormInput :field="form.report_content_country" />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__rowItem">
                        <FormInput :field="form.report_content_signature" />
                    </div>
                </div>
            </div><!-- .reportContent__left -->
        </div><!-- .reportContent__formGrid -->
        <div class="reportContent__footer">
            <div class="form__row form__row--submit">
                <div class="form__rowItem form__rowItem--submitCenter">
                    <FormButton
                        id="reportContent__submit"
                        type="submit"
                        classes="button button--primary button--medium"
                        :label="trans('BUTTON_REPORT_CONTENT')"
                        @click="onButtonSubmit" />
                    <FormInput
                        type="hidden"
                        :field="form.report_content_referer" />
                    <FormInput
                        type="hidden"
                        :field="form.report_content__token" />
                    <FormRecaptcha
                        v-if="fieldRecaptcha"
                        :triggered="triggered"
                        :sitekey="sitekey" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import Translator from 'tools/trans';
    import formBaseMixin from 'mixins/formBaseMixin';
    import initRecaptchaMixin from 'mixins/initRecaptchaMixin';
    import { getFormFields } from 'tools/formFieldData';
    import FormInput from 'components/form/formInput';
    import FormCheckbox from 'components/form/formCheckbox';
    import FormRadio from 'components/form/formRadio';
    import FormButton from 'components/form/formButton';
    import FormRecaptcha from 'components/recaptcha';

    export default {
        components: {
            FormInput,
            FormCheckbox,
            FormRadio,
            FormButton,
            FormRecaptcha,
        },
        mixins: [initRecaptchaMixin, formBaseMixin],
        props: {
            sitekey: { type: String, default: null },
            fieldRecaptcha: { type: Object, default: null },
            fieldRadio: { type: Object, default: null },
            fieldToken: { type: Object, default: null },
        },
        data() {
            return {
                form: getFormFields(),
            };
        },
        methods: {
            trans: Translator.trans,
            onButtonSubmit() {
                this.checkValidityHTML5();
            },
        },
    };
</script>
